import discountModel from "@/models/discount";
import pricesModel from "@/models/prices";

export default class {
  constructor() {
    this.id = 0;
    this.image = {};
    this.priceDutyFree = 0;
    this.translations = {};
    this.discounts = [];
    this.prices = {};

    // Require tva rate
    this.price = 0;
    this.discountedPrice = 0;
  }

  hydrate(data) {
    if (data.id) this.id = data.id;
    if (data.priceDutyFree) this.priceDutyFree = data.priceDutyFree;

    if (data.prices) {
      const _p = new pricesModel();
      _p.hydrate(data.prices);
      this.prices = _p;
    }

    if (data.discounts) {
      for(let d of data.discounts) {
        const _d = new discountModel();
        _d.hydrate(d);
        this.discounts.push(_d);
      }
    }

    if (void 0 !== data.equipment) {
      if(data.equipment.image) this.image = data.equipment.image;
      if(data.equipment.translations) this.translations = data.equipment.translations;
    }
  }
}
